//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const COMMON_LINE_STYLE_BROKEN = {
    line: {
        lineStyle: {
            width: 2,
        },
        symbolSize: 0,
        smooth: false,
    },
};
